import { render, staticRenderFns } from "./PackageInfoBox.vue?vue&type=template&id=04f8abf4&scoped=true"
import script from "./PackageInfoBox.vue?vue&type=script&lang=js"
export * from "./PackageInfoBox.vue?vue&type=script&lang=js"
import style0 from "./PackageInfoBox.vue?vue&type=style&index=0&id=04f8abf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8abf4",
  null
  
)

export default component.exports